import React from 'react';
import { Breadcrumbs as BreadcrumbsHM } from './hm';
const Breadcrumbs = (props) => {
    return React.createElement(BreadcrumbsHM, Object.assign({}, props));
};
export default Breadcrumbs;
//# sourceMappingURL=Breadcrumbs.js.map